module.exports = __webpack_public_path__ + "img/VinoTintoCastillodeSantiago.75943a78.jpg";